import { format } from 'date-fns';
import { getMoonPhase } from '../data/moon';
import {
  getMoonSignLongitude,
  getMercuryVibe,
  getTarotOfDay,
} from '../data/astrology';

/**
 * Renders the Moon & tarot panel into the given container.
 */
export function renderMoonTarotCard(container: HTMLElement): void {
  const now = new Date();
  const phase = getMoonPhase(now);
  const moonSign = getMoonSignLongitude(now);
  const mercury = getMercuryVibe(now);
  const tarot = getTarotOfDay(now);

  const panel = document.createElement('div');
  panel.className = 'panel';
  panel.innerHTML = `
    <div class="panel-title">🌙 Moon & tarot</div>
    <div class="moon-phase-box">
      <div class="moon-circle" title="${phase.illumination}% illuminated"></div>
      <div class="moon-info">
        <div class="phase-name">${phase.name}</div>
        <div class="next-full">${phase.illumination}% illuminated · day ${phase.ageDays} of ${phase.cycleDays}</div>
      </div>
    </div>
    <p class="moon-phase-note">${phase.note}</p>
    <div class="moon-dates">
      <div class="moon-date-block">
        <strong>Next full</strong>
        ${format(phase.nextFullMoon, 'EEE, MMM d')} · ${phase.daysUntilFull}d
      </div>
      <div class="moon-date-block">
        <strong>Next new</strong>
        ${format(phase.nextNewMoon, 'EEE, MMM d')} · ${phase.daysUntilNew}d
      </div>
    </div>
    <div class="moon-meta">
      <div class="moon-meta-row"><strong>Moon in ${moonSign.sign}</strong> (~${moonSign.degreeInSign}° of the sign)</div>
      <div class="moon-meta-row">Tropical longitude is an approximation (~±1°).</div>
      <div class="moon-meta-row">☿ <strong>Mercury vibe:</strong> ${mercury}</div>
    </div>
    <div class="tarot-pull">
      <div class="card-name">Card of the day — ${tarot.card}</div>
      <div class="panel-content" style="margin:0;">${tarot.description}</div>
    </div>
  `;
  container.appendChild(panel);
}
